var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { CoverResizer } from '../../../ts/components/CoverResizer';
export class SingleBook extends Component {
    constructor() {
        super('SingleBook', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // issue switcher
            $('.btn-open-issue').on('click', (event, button) => {
                event.preventDefault();
                const type = button.data('type');
                $('.book-issue, .book-informations .book-thumbnail').addClass('d-none').search(`[data-type="${type}"]`).removeClass('d-none');
                $('.btn-open-issue').removeClass('btn-primary').addClass('btn-outline-primary').search(`[data-type="${type}"]`).addClass('btn-primary').removeClass('btn-outline-primary');
                if ($(`.book-thumbnail[data-type="${type}"]`).length === 0)
                    $('.book-thumbnail').first().removeClass('d-none');
                CoverResizer.resize();
            });
            // Display issue according to hash
            if (location.hash.search('issue-') !== -1) {
                let issue_parts = location.hash.split(',');
                let issue = issue_parts[0].replace('#issue-', '');
                $('.btn-open-issue').search(`[data-type="${issue}"]`).trigger('click');
                if (issue_parts[1]) {
                    setTimeout(() => {
                        $(`a[href="#${issue_parts[1]}"]`).trigger('click');
                    }, 500);
                }
            }
            this.success();
        });
    }
}
